import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
  // A list of all locales that are supported (Wave 1 & Wave 2 active)
  locales: ["en", "de", "es", "fr", "it", "pt-br", "ja", "ko", "zh-tw"],

  // Used when no locale matches
  defaultLocale: "en",

  localePrefix: "as-needed",

  // Disable automatic locale redirection based on browser headers/IP
  // Ensures search engines (Googlebot) and direct URL visits never get redirected
  localeDetection: false,

  // Disable next-intl's automatic Link response headers because our app uses dynamic localized slugs
  // and defines accurate canonical & alternate hreflang tags directly in page metadata
  alternateLinks: false,
});

export type Locale = (typeof routing.locales)[number];
